import styled, { keyframes } from "styled-components";

const blinkAnimation = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`;

export const HeroSectionContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 67vh;
  align-content: center;
  padding: 10vw 8vw 5vw 8vw;
  background: transparent;

  .intro-section {
    display: flex;
    flex-direction: column;
    text-align: start;
    justify-content: space-between;
    margin-right: 1.5rem;
    h1 {
      color: #ff8412;
      font-size: 3.5rem;
      margin: 0 0;
      animation: ${blinkAnimation} 2s infinite ease-in-out;
    }
    h2 {
      font-size: 1.75rem;
      margin: 1rem 0 1rem 0;
    }

    p {
      font-size: 1.5rem;
    }

    .contact-us {
      background-color: #ff8412;
      padding: 0;
      font-size: 1.25rem;
      font-weight: 600;
      border-radius: 0.8rem;
      border: 1px solid #172736;
      height: 3rem;
      width: 16rem;
      color: #fff;
      animation: ${blinkAnimation} 2s infinite ease-in-out;
    }
    .contact-us:hover {
      background-color: #a76323;
      color: #ded9e0;
      cursor: pointer;
    }
  }

  .image-section {
    margin-left: 1.5rem;
    background-color: transparent;
    align-content: center;
    // #183652
    // #1c568d
    //  #142d44;
    img {
      border-radius: 0.5rem;
      width: 100%;
      height: auto;
      max-width: 100%;
    }
  }
`;
